const TestIds = Object.freeze({
    Accordion: "Accordion",
    AccordionPanel: "AccordionPanel",
    AccordionPanelContent: "AccordionPanelContent",
    AccordionPanelIconsWrapper: "AccordionPanelIconsWrapper",
    AccountBalanceTable: "AccountBalanceTable",
    AccountingBalance: "AccountingBalance",
    ActionIconWrapper: "ActionIconWrapper",
    ActionItemWrapper: "ActionItemWrapper",
    AdditionalInfo: "AdditionalInfo",
    AdditionalGrantsSettings: "AdditionalGrantsSettings",
    AdditionalPayrollSettings: "AdditionalPayrollSettings",
    AfterTokensText: "AfterTokensText",
    AgendaSpan: "AgendaSpan",
    Alert: "Alert",
    AlertAction: "AlertAction",
    AlertContent: "AlertContent",
    AlertSubtitle: "AlertSubtitle",
    AlertTitle: "AlertTitle",
    AmountOverview: "AmountOverview",
    AppliedSubTitle: "AppliedSubTitle",
    Attachment: "Attachment",
    AttachmentName: "AttachmentName",
    AuditTrail: "AuditTrail",
    AuditTrailLayer: "AuditTrailLayer",
    AuditTrailLineOrder: "AuditTrailLineOrder",
    AutoCompleteGroup: "AutoCompleteGroup",
    AutoCompleteHeader: "AutoCompleteHeader",
    BackgroundJobs: "BackgroundJobs",
    BackgroundJobsItem: "BackgroundJobsItem",
    BackgroundJobsItemsList: "BackgroundJobsItemsList",
    BackgroundJobsStatus: "BackgroundJobsStatus",
    Badge: "Badge",
    BankAccountFilterTile: "BankAccountFilterTile",
    Balance: "Balance",
    BoldText: "BoldText",
    BottomTextLabel: "BottomTextLabel",
    BottomTextLink: "BottomTextLink",
    Breadcrumb: "Breadcrumb",
    BreadcrumbItem: "BreadcrumbItem",
    BusyIndicator: "BusyIndicator",
    BusyWrapper: "BusyWrapper",
    Button: "Button",
    ButtonGroup: "ButtonGroup",
    ButtonsFooter: "ButtonsFooter",
    Calendar: "Calendar",
    CalendarDay: "CalendarDay",
    CalendarDayAbsence: "CalendarDayAbsence",
    CalendarDayAbsences: "CalendarDayAbsences",
    CalendarDayDetail: "CalendarDayDetail",
    CalendarDayNumber: "CalendarDayNumber",
    CalendarDayRows: "CalendarDayRows",
    CalendarDayWorkTime: "CalendarDayWorkTime",
    CalendarGrid: "CalendarGrid",
    CalendarMonthlyDetail: "CalendarMonthlyDetail",
    CalculatedCoefficient: "CalculatedCoefficient",
    CalculatedTax: "CalculatedTax",
    Card: "Card",
    CashboxFilterTile: "CashboxFilterTile",
    ChangeValueDialog: "ChangeValueDialog",
    Chat: "Chat",
    ChatDetail: "ChatDetail",
    CheckList: "CheckList",
    CheckListItem: "CheckListItem",
    Checkbox: "Checkbox",
    CheckboxContainer: "CheckboxContainer",
    CheckboxGroup: "CheckboxGroup",
    CheckboxGroupColumn: "CheckboxGroupColumn",
    CheckboxGroupWrapper: "CheckboxGroupWrapper",
    CheckboxLabel: "CheckboxLabel",
    CheckboxWrapper: "CheckboxWrapper",
    Circle: "Circle",
    ClickableText: "ClickableText",
    ClosingAttachmentsTable: "ClosingAttachmentsTable",
    ClosingDialogGrid: "ClosingDialogGrid",
    FinancialOverviewTable: "ClosingOverviewTable1",
    AnnualNetTurnoverDepreciationTable: "ClosingOverviewTable2",
    CollapsibleContent: "CollapsibleContent",
    CollapsibleSection: "CollapsibleSection",
    CollapsibleSectionBody: "CollapsibleSectionBody",
    Color: "Color",
    ColorPicker: "ColorPicker",
    ColorPickerMenu: "ColorPickerMenu",
    ColumnSortIconWrapper: "ColumnSortIconWrapper",
    CompanyAccountingType: "CompanyAccountingType",
    CompanyAccountingTypeCard: "CompanyAccountingTypeCard",
    CompanyAvatar: "CompanyAvatar",
    CompanyDashboard: "CompanyDashboard",
    CompanyOpener: "CompanyOpener",
    CompanySelector: "CompanySelector",
    CompanyTile: "CompanyTile",
    CompanyTileBody: "CompanyTileBody",
    CompanyTileContent: "CompanyTileContent",
    CompanyTileFooter: "CompanyTileFooter",
    CompanyTileHeader: "CompanyTileHeader",
    ComparisonBorder: "ComparisonBorder",
    ConditionalFilterDialog: "ConditionalFilterDialog",
    ConfigurationColumn: "ConfigurationColumn",
    ConfigurationGroup: "ConfigurationGroup",
    ConfigurationItem: "ConfigurationItem",
    ConfigurationItemAggregationSelector: "ConfigurationItemAggregationSelector",
    ConfigurationItemValue: "ConfigurationItemValue",
    ConfigurationList: "ConfigurationList",
    ConfigurationListAddAggregationButton: "ConfigurationListAddAggregationButton",
    ConfirmationHeader: "ConfirmationHeader",
    Content: "Content",
    ContentAfterRow: "ContentAfterRow",
    ContentColumn: "ContentColumn",
    ContentEditableMessage: "ContentEditableMessage",
    ContextMenu: "ContextMenu",
    CreditCard: "CreditCard",
    CustomerCompanySelector: "CustomerCompanySelector",
    Dashboard: "Dashboard",
    DashboardGroupTileDialog: "DashboardGroupTileDialog",
    DashboardInfoTile: "DashboardInfoTile",
    DashboardInfoTileCell: "DashboardInfoTileCell",
    DashboardInfoTileCellLabel: "DashboardInfoTileCellLabel",
    DashboardInfoTileCellValue: "DashboardInfoTileCellValue",
    DashboardItem: "DashboardItem",
    DashboardTile: "DashboardTile",
    DashboardTileHeading: "DashboardTileHeading",
    DashedResizeLine: "DashedResizeLine",
    DataBoxInfo: "DataBoxInfo",
    DataBoxPermissionRow: "DataBoxPermissionRow",
    DatePickerBase: "DatePickerBase",
    DatePickerCalendar: "DatePickerCalendar",
    DatePickerMonthLabel: "DatePickerMonthLabel",
    DatePickerNextMonth: "DatePickerNextMonth",
    DatePickerPopup: "DatePickerPopup",
    DatePickerPopupBackButton: "DatePickerPopupBackButton",
    DatePickerPrevMonth: "DatePickerPrevMonth",
    DatePickerWeeks: "DatePickerWeeks",
    DatePickerYearLabel: "DatePickerYearLabel",
    DateRangePicker: "DateRangePicker",
    DayCurrent: "DayCurrent",
    DayCurrentMonth: "DayCurrentMonth",
    DayCurrentSelected: "DayCurrentSelected",
    DayLabel: "DayLabel",
    DayOutsideMonth: "DayOutsideMonth",
    DaySelected: "DaySelected",
    DaysLeftText: "DaysLeftText",
    DaysRemaining: "DaysRemaining",
    DeleteLogHeader: "DeleteLogHeader",
    Description: "Description",
    DetectedChangeLine: "DetectedChangeLine",
    DeviceBody: "DeviceBody",
    Dialog: "Dialog",
    DialogBody: "DialogBody",
    DialogHeader: "DialogHeader",
    DialogSubTitle: "DialogSubTitle",
    DialogTitle: "DialogTitle",
    Document: "Document",
    DomainName: "DomainName",
    DraftsTable: "DraftsTable",
    DraftTimeStamp: "DraftTimeStamp",
    DrilldownWrapper: "DrilldownWrapper",
    DropArea: "DropArea",
    DropdownIcon: "DropdownIcon",
    EditVariantsGrid: "EditVariantsGrid",
    EditableText: "EditableText",
    EditableTextReadLabel: "EditableTextReadLabel",
    EditableWindowCloseIcon: "EditableWindowCloseIcon",
    ElSubDetailCancellationSection: "ElSubDetailCancellationSection",
    ElSubDetailDocumentsThisPeriodList: "ElSubDetailDocumentsThisPeriodList",
    ElSubDetailIncludedDocuments: "ElSubDetailIncludedDocuments",
    ElSubDetailLinks: "ElSubDetailLinks",
    ElSubPeriodCell: "ElSubPeriodCell",
    ErrorStepper: "ErrorStepper",
    ErrorText: "ErrorText",
    ErrorWrapper: "ErrorWrapper",
    ExpandButton: "ExpandButton",
    FastEntryItem: "FastEntryItem",
    FastEntryList: "FastEntryList",
    FastEntryListHeader: "FastEntryListHeader",
    FastEntryListLastField: "FastEntryListLastField",
    FastEntryListVirtualization: "FastEntryListVirtualization",
    Field: "Field",
    FieldContent: "FieldContent",
    FieldGroup: "FieldGroup",
    FieldGroupToggle: "FieldGroupToggle",
    FieldLabel: "FieldLabel",
    FieldsWrapper: "FieldsWrapper",
    FileIconWrapper: "FileIconWrapper",
    FileInputFileNames: "FileInputFileNames",
    FileName: "FileName",
    FileStrip: "FileStrip",
    FileStripItem: "FileStripItem",
    FileText: "FileText",
    FileUploader: "FileUploader",
    FileViewer: "FileViewer",
    FilterBar: "FilterBar",
    FilterBarToggle: "FilterBarToggle",
    FilterReadOnlyGroup: "FilterReadOnlyGroup",
    FloatingText: "FloatingText",
    Footer: "Footer",
    FormContent: "FormContent",
    FormGroup: "FormGroup",
    FormGroupAction: "FormGroupAction",
    FormGroupActions: "FormGroupActions",
    FormGroupAuditTrailLayer: "FormGroupAuditTrailLayer",
    FormGroupBody: "FormGroupBody",
    FormGroupHeader: "FormGroupHeader",
    FormGroupLine: "FormGroupLine",
    FormTableList: "FormTableList",
    FormView: "FormView",
    GainRow: "GainRow",
    GainRowLabel: "GainRowLabel",
    GainRowValue: "GainRowValue",
    GrantsDocsTableGroup: "GrantsDocsTableGroup",
    GroupedFields: "GroupedFields",
    Header: "Header",
    HeaderInfoText: "HeaderInfoText",
    HeaderSubtitle: "HeaderSubtitle",
    HeaderTitle: "HeaderTitle",
    HiddenFileInput: "HiddenFileInput",
    HiddenFileInputImportXML: "HiddenFileInputImportXML",
    HiddenItems: "HiddenItems",
    Hotspots: "Hotspots",
    Icon: "Icon",
    IconBar: "IconBar",
    IconBarItem: "IconBarItem",
    IconButton: "IconButton",
    ImageWrapper: "ImageWrapper",
    ImportSettings: "ImportSettings",
    ImportSettingsColumn: "ImportSettingsColumn",
    ImportSettingsColumnHeader: "ImportSettingsColumnHeader",
    ImportSettingsDragItem: "ImportSettingsDragItem",
    ImportSettingsDropItemDroppable: "ImportSettingsDropItemDroppable",
    ImportSettingsDropItemLabel: "ImportSettingsDropItemLabel",
    ImportSettingsDropItemSelector: "ImportSettingsDropItemSelector",
    ImportSettingsGrid: "ImportSettingsGrid",
    ImportSettingsValuePreview: "ImportSettingsValuePreview",
    InboxFakeSplitter: "InboxFakeSplitter",
    InboxPage: "InboxPage",
    Infinity: "Infinity",
    InfoAlertTop: "InfoAlertTop",
    InitialAccountBalancesGrid: "InitialAccountBalancesGrid",
    InitialAccountBalancesGridCell: "InitialAccountBalancesGridCell",
    Input: "Input",
    InputStatus: "InputStatus",
    InputWrapper: "InputWrapper",
    InventoryGrid: "InventoryGrid",
    ItemsCorrectionSummaryTable: "ItemsCorrectionSummaryTable",
    ItemsSummaryTable: "ItemsSummaryTable",
    LabelDescription: "LabelDescription",
    LabeledWriteLine: "LabeledWriteLine",
    LastUpdate: "LastUpdate",
    Line: "Line",
    ListItemRow: "ListItemRow",
    ListItemRowLabel: "ListItemRowLabel",
    ListItemRowValue: "ListItemRowValue",
    LoginInputField: "LoginInputField",
    LoginPage: "LoginPage",
    LostPass: "LostPass",
    Menu: "Menu",
    MenuItem: "MenuItem",
    Message: "Message",
    MessageContent: "MessageContent",
    MessageStreamWrapper: "MessageStreamWrapper",
    MonthsGrid: "MonthsGrid",
    MonthCheckboxSelector: "MonthCheckboxSelector",
    MoreItems: "MoreItems",
    Name: "Name",
    NewMessage: "NewMessage",
    NoData: "NoData",
    NoPreview: "NoPreview",
    Notification: "Notification",
    NotificationAlert: "NotificationAlert",
    NotificationDescription: "NotificationDescription",
    NotificationInfo: "NotificationInfo",
    NotificationSettings: "NotificationSettings",
    NotificationSettingsRow: "NotificationSettingsRow",
    Notifications: "Notifications",
    NotificationsCount: "NotificationsCount",
    ObjectList: "ObjectList",
    ObjectListItem: "ObjectListItem",
    OrganizationTile: "OrganizationTile",
    Page: "Page",
    PageControlFirstPage: "PageControlFirstPage",
    PageControlLastPage: "PageControlLastPage",
    PageControlNextPage: "PageControlNextPage",
    PageControlPreviousPage: "PageControlPreviousPage",
    PageControls: "PageControls",
    PageCount: "PageCount",
    Paginator: "Paginator",
    PairingRow: "PairingRow",
    PairingValue: "PairingValue",
    PairingValueTitle: "PairingValueTitle",
    PaymentOrderGrid: "PaymentOrderGrid",
    PaymentTypeDescription: "PaymentTypeDescription",
    PdfWrapper: "PdfWrapper",
    PencilDialog: "PencilDialog",
    PermissionComponent: "PermissionComponent",
    PermissionsGrid: "PermissionsGrid",
    PlaceholderLine: "PlaceholderLine",
    PreviewCanvas: "PreviewCanvas",
    Price: "Price",
    PrimaryContent: "PrimaryContent",
    PrimarySubTitle: "PrimarySubTitle",
    ProductTypeItem: "ProductTypeItem",
    ProgressBar: "ProgressBar",
    ProgressBarDescription: "ProgressBarDescription",
    ProgressValue: "ProgressValue",
    RadioButton: "RadioButton",
    RadioButtonGroup: "RadioButtonGroup",
    RadioButtonLabel: "RadioButtonLabel",
    ReadOnlyList: "ReadOnlyList",
    ReadOnlyListItem: "ReadOnlyListItem",
    ReadOnlyListItemLabel: "ReadOnlyListLabel",
    ReadOnlyListItemValue: "ReadOnlyListValue",
    RequiredMark: "RequiredMark",
    RetirementSavingsRow: "RetirementSavingsRow",
    ScrollBar: "ScrollBar",
    SectionTitle: "SectionTitle",
    SegmentedButton: "SegmentedButton",
    Select: "Select",
    SelectInputLabel: "SelectInputLabel",
    SelectMenu: "SelectMenu",
    SelectMenuColumn: "SelectMenuColumn",
    SelectMenuGroup: "SelectMenuGroup",
    SelectMenuGroupTitle: "SelectMenuGroupTitle",
    SelectMenuHeader: "SelectMenuHeader",
    SelectMenuItem: "SelectMenuItem",
    SelectSearchInput: "SelectSearchInput",
    Separator: "Separator",
    SettingLabel: "SettingLabel",
    SettingRow: "SettingRow",
    SettingsList: "SettingsList",
    SettingsListItem: "SettingListItem",
    ShellIconsGroup: "ShellIconsGroup",
    Shellbar: "Shellbar",
    ShellbarContent: "ShellbarContent",
    ShellbarContentGroup: "ShellbarContentGroup",
    ShellbarContentGroupItem: "ShellbarContentGroupItem",
    ShellbarContentGroupTitle: "ShellbarContentGroupTitle",
    SimpleGridTable: "SimpleGridTable",
    SimpleItem: "SimpleItem",
    SimpleTable: "SimpleTable",
    Slider: "Slider",
    SliderMark: "SliderMark",
    SliderMarkLabel: "SliderMarkLabel",
    SliderThumb: "SliderThumb",
    SliderThumbLabel: "SliderThumbLabel",
    SmallHeader: "SmallHeader",
    SortableList: "SortableList",
    SortableListItem: "SortableListItem",
    SpiderAnim: "SpiderAnim",
    SplitDialogTitle: "SplitDialogTitle",
    SplitDialogValue: "SplitDialogValue",
    Splitter: "Splitter",
    State: "State",
    StaticItems: "StaticItems",
    Stepper: "Stepper",
    SubItem: "SubItem",
    SubItemDescription: "SubItemDescription",
    SubItemTitle: "SubItemTitle",
    Subtitle: "Subtitle",
    Summary: "Summary",
    SummaryItem: "SummaryItem",
    SummaryItemLabel: "SummaryItemLabel",
    SummaryItemValue: "SummaryItemValue",
    SvgImage: "SvgImage",
    Switch: "Switch",
    SwitchBody: "SwitchBody",
    SwitchCircle: "SwitchCircle",
    SwitchPageInfo: "SwitchPageInfo",
    SwitchPageLink: "SwitchPageLink",
    InputSyncSymbol: "InputSyncSymbol",
    Tab: "Tab",
    TabContent: "TabContent",
    TabCount: "TabCount",
    Table: "Table",
    TableAggregationRow: "TableAggregationRow",
    TableCell: "TableCell",
    TableCellBeforeContent: "TableCellBeforeContent",
    TableCellAfterContent: "TableCellAfterContent",
    TableCellContent: "TableCellContent",
    TableCellHoverContent: "TableCellHoverContent",
    TableGroupRow: "TableGroupRow",
    TableHeader: "TableHeader",
    TableHeaderCell: "TableHeaderCell",
    TableHeaderCellContent: "TableHeaderCellContent",
    TableHeaderMetaColumn: "TableHeaderMetaColumn",
    TableHeaderMetaColumnContent: "TableHeaderMetaColumnContent",
    TableHeaderMetaColumnLabel: "TableHeaderMetaColumnLabel",
    TableMasterAction: "TableMasterAction",
    TableMergedRow: "TableMergedRow",
    TableRow: "TableRow",
    TableRowAction: "TableRowAction",
    TableSortingItem: "TableSortingItem",
    Tabs: "Tabs",
    TabsMenu: "TabsMenu",
    TaskRow: "TaskRow",
    TaskRowCaret: "TaskRowCaret",
    TaskRowContent: "TaskRowContent",
    TaskRowStatusIcon: "TaskRowStatusIcon",
    Tasks: "Tasks",
    TaxDocumentsTable: "TaxDocumentsTable",
    TaxReductionTable: "TaxReductionTable",
    TenantSelector: "TenantSelector",
    TenantTitle: "TenantTitle",
    Text: "Text",
    ChatMessageInput: "ChatMessageInput",
    ChatMessageStream: "ChatMessageStream",
    Title: "Title",
    TitleColumn: "TitleColumn",
    Token: "Token",
    TokenInput: "TokenInput",
    Tokenizer: "Tokenizer",
    Toolbar: "Toolbar",
    Tooltip: "Tooltip",
    TruncatedValue: "TruncatedValue",
    UnpostedTable: "UnpostedTable",
    UnderTableText: "UnderTableText",
    UserName: "UserName",
    ValueHelper: "ValueHelper",
    ValueHelperAddButton: "ValueHelperAddButton",
    ValueHelperRow: "ValueHelperRow",
    ValuePicker: "ValuePicker",
    ValuePickerNextValue: "ValuePickerNextValue",
    ValuePickerNextValueButton: "ValuePickerNextValueButton",
    ValuePickerPrevValue: "ValuePickerPrevValue",
    ValuePickerPrevValueButton: "ValuePickerPrevValueButton",
    ValuePickerValue: "ValuePickerValue",
    ValueWrapper: "ValueWrapper",
    VariantLabel: "VariantLabel",
    VariantSelector: "VariantSelector",
    View: "View",
    WelcomeScreen: "WelcomeScreen",
    Wizard: "Wizard",
    WorkDatePicker: "WorkDatePicker",
    WriteLine: "WriteLine",
    WriteLineLabel: "WriteLineLabel",
    YearSwitcher: "YearSwitcher",
    YearsGrid: "YearsGrid"
});

export default TestIds;
